/** @file Button: the ui-kit push button (default, primary, danger or ghost) in the dark theme. */
import type { ButtonHTMLAttributes, ReactElement } from 'react';

/** The native button props plus a visual `variant` (default `default`). */
export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & { variant?: 'default' | 'primary' | 'danger' | 'ghost' };

/** A themed `<button>`; `type` defaults to `button` so it never submits a form by accident. */
export function Button({ variant = 'default', className, type = 'button', ...rest }: ButtonProps): ReactElement {
  const cls = `p3-btn p3-btn-${variant}${className === undefined ? '' : ` ${className}`}`;
  return <button type={type} className={cls} {...rest} />;
}
